import { type AxiosRequestConfig } from 'axios'

const restoreValidation = (token: string): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/auth/restore-validation',
    data: {
      token,
    },
  }
}

export { restoreValidation }
